import React from 'react'
import { makeStyles } from '@material-ui/core';
import VideoPlayer   from './VideoPlayer';
import Options  from './Options';
import Notification   from './Notification';

const useStyles = makeStyles((theme) => ({
  image: {
    marginLeft: '15px',
  },
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
  },
}));


const CallPage = () => {
  const css = useStyles();
  return (
    <div className={css.wrapper}>
        <VideoPlayer/>
        <Options>
            <Notification/>
        </Options>          
    </div>
  )
}

export default CallPage;